import _ from 'lodash';
import * as stateManagement from '#packages/stateManagement';
import * as helpIds from '#packages/helpIds';
import { getRefComponentRootChild } from '#packages/documentServices';
import * as formPlugin from './formPlugin';
import * as componentPastePlugins from './componentPastePlugins';
import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
import { translate } from '#packages/i18n';

function runFormPlugin(compTypes: string, editorAPI: EditorAPI) {
  const formRefs =
    editorAPI.components.get.byType_DEPRECATED_BAD_PERFORMANCE(compTypes);
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/for-each
  _.forEach(formRefs, function (compRef) {
    const data = editorAPI.components.data.get(compRef);
    const clonedData = _.clone(data);
    formPlugin.updateDataWithDefaults(data, editorAPI);
    if (!_.isEqual(data, clonedData)) {
      editorAPI.components.data.update(compRef, data);
    }
  });
}

function registerComponentPastePlugins(editorAPI: EditorAPI) {
  editorAPI.registerPasteComponentPlugin(
    '*',
    componentPastePlugins.adjustMobileTextScaling,
  );
  editorAPI.registerPasteComponentPlugin(
    'platform.components.AppController',
    componentPastePlugins.removeConnectedComponentsIfAlreadyExist,
  );
  editorAPI.registerPasteComponentPlugin(
    '*',
    componentPastePlugins.removeSerializedDataId,
  );
  editorAPI.registerAddComponentPlugin(
    '*',
    componentPastePlugins.stretchAppWidgetBottomOnConnectedComponentPaste,
  );
}

function registerCannotRemovePlugin(editorAPI: EditorAPI) {
  editorAPI.registerCannotRemovePlugin('*', (compRef: CompRef) => {
    const { isRefComponent } = stateManagement.components.selectors;

    const connectedComponent = isRefComponent(compRef, editorAPI.dsRead)
      ? getRefComponentRootChild(editorAPI.dsRead, compRef)
      : compRef;
    const stageData =
      editorAPI.dsRead.platform.controllers.getConnectedComponentStageData(
        connectedComponent,
      );
    //@ts-expect-error
    const isEssential = stageData?.behavior?.essential;
    //@ts-expect-error
    const preventHide = isEssential || stageData?.behavior?.preventHide;

    if (preventHide) {
      editorAPI.store.dispatch(
        stateManagement.notifications.actions.showUserActionNotification({
          message: 'PLATFORM_Notification_open_close_cannot_delete_element',
          title: 'Delete by ref inner comp',
          type: 'error',
          link: {
            caption: 'Notifications_Learn_More_Link',
            onNotificationLinkClick: () => {
              editorAPI.panelManager.openHelpCenter(
                helpIds.NOTIFICATIONS.CANNOT_DELETE_REF_COMPONENT_INNER_COMP,
              );
            },
          },
        }),
      );
    }
    const componentData = editorAPI.components.data.get(compRef);
    if (!componentData?.appDefinitionId) {
      return;
    }
    const appDefinitionId = componentData.appDefinitionId;
    const widgetName = editorAPI.components.getDisplayName(compRef);
    const appName =
      editorAPI.platform.getAppDataByAppDefId(appDefinitionId)
        ?.appDefinitionName;
    const helpId = translate(
      'platformized_app_delete_unremovable_componant_notification_article',
    );
    editorAPI.store.dispatch(
      stateManagement.notifications.actions.showUserActionNotification({
        message: translate(
          'platformized_app_delete_unremovable_componant_notification',
          {
            widget_name: widgetName,
            app_name: appName,
          },
        ),
        appDefinitionId,
        origin: 'cannotRemovePlugin',
        shouldTranslate: false,
        title: `non-removable component appDefinitionId - ${appDefinitionId}`,
        type: 'warning',
        link: {
          caption: translate('Notifications_Learn_More_Link'),
          onNotificationLinkClick: () => {
            editorAPI.panelManager.openHelpCenter(helpId);
          },
        },
      }),
    );
  });
}

export default [
  // @ts-expect-error
  runFormPlugin.bind(null, [
    'wysiwyg.viewer.components.ContactForm',
    'wysiwyg.viewer.components.DynamicContactForm',
    'wysiwyg.common.components.subscribeform.viewer.SubscribeForm',
  ]),
  registerCannotRemovePlugin,
  registerComponentPastePlugins,
];
